<template>
	<div>
		<MedicationReportSearchableSelect :data-options="filteredReportArray"
			:editObject="existingReport" :enable-validation="false"
			validationMessage="" label-text="Bestehenden Bericht wählen" :enable-order="true"
			:select="(object) => (existingReport = object)" />
		<b-field class="mt-5" expanded>
			<template #label>
				<div class="align-content-center" style="display: inline-flex">
					<p>Neuen Bericht anlegen</p>
				</div>
				<hr class="m-0 mt-1 mb-1" style="border-bottom:1px solid gray;">
			</template>
		</b-field>
	</div>
</template>

<script>

import { mapGetters } from "vuex";
import { minLength, required, minValue } from "vuelidate/lib/validators";
import Parse from "parse/dist/parse.min.js";

import MedicationReportSearchableSelect from "@/components/helper/SearchableSelects/MedicationReportSearchableSelect.vue";

export default {
	name: "MedicationReportInputSelect",
	components: {
		MedicationReportSearchableSelect,
	},
	props: [],
	data() {
		return {
			existingReport: undefined
		};
	},
	mounted() {	},
	computed: {
		...mapGetters({
			filteredReportArray: "medicationReport/getData",
		}),
	},
	methods: { },
	watch: {
		existingReport(newVal) {
			if (newVal) {
				for (var i = 0; i < this.filteredReportArray.length; i++) {
					if (newVal.id == this.filteredReportArray[i].objectId) {
						this.$emit("emit-existing-report-object-selected", this.filteredReportArray[i])
						break;
					}
				}

			}

		},
	}
}

</script>

<style scoped></style>
